import { StyledIcon } from 'components/elements/Icon/Icon.styled';
import { styled } from 'styles';
import { rowCellHeight } from './Table.config';
import { getCellAlignment } from './Table.utils';
import { StyledTableCellProps } from './types';

export const BaseTableCell = styled.div<StyledTableCellProps>`
  align-items: center;
  display: flex;
  overflow: hidden;
  white-space: nowrap;
`;

export const StyledTableCell = styled(BaseTableCell)`
  height: ${rowCellHeight}px;
  justify-content: ${({ $align }) => getCellAlignment($align)};
  padding: 0 ${({ theme }) => theme.spacing.absolute.smaller};
  user-select: none;
  white-space: pre;
  -webkit-tap-highlight-color: transparent;

  ${StyledIcon} {
    font-size: 1.4em;
  }
`;

BaseTableCell.displayName = 'BaseTableCell';
StyledTableCell.displayName = 'TableCell.Styled';
